<template>
  <layout name="LayoutDefault">
    <div class="Contact">
      <!-- Page Content -->
      <div class="container">
        <!-- Page Features -->
        <div class="contents">
          <div class="row ">
            <div class="alert alert-success col-lg-12">
                     আপনার অর্ডারটি সম্পন্ন হয়নি । ধন্যবাদ
            </div>
          </div>
        </div>
      </div>
      <!-- /.container -->
    </div>
  </layout>
</template>

<script>
import Layout from "../layouts/Layout";

export default {
  name: `login`,
  components: {
    Layout
  },
  data() {
    return {
      errors: [],
    };
  },
  mounted(){
    localStorage.setItem("cartCount", "0");
    $(".cart-count").text(0);
  }
};
</script>
